const MapIndicator = () => {
    return (
        <div className="flex h-full w-fit flex-col items-center justify-end space-y-1">
            <div className="flex w-full  items-center justify-start space-x-3">
                <div className="h-3 w-3 rounded-full bg-primary2" />
                <p className="text-h5 text-black40">Wall</p>
            </div>
            <div className="flex w-full  items-center justify-start space-x-3">
                <div className="h-3 w-3 rounded-full bg-yellow-400" />
                <p className="text-h5 text-black40">Bright Area</p>
            </div>
            <div className="flex w-full  items-center justify-start space-x-3">
                <div className="h-3 w-3 rounded-full bg-amber-500" />
                <p className="text-h5 text-black40">Slowdown Area</p>
            </div>
            <div className="flex w-full  items-center justify-start space-x-3">
                <div className="h-3 w-3 rounded-full bg-violet-700" />
                <p className="text-h5 text-black40">Slope</p>
            </div>
            <div className="flex w-full  items-center justify-start space-x-3">
                <div className="h-3 w-3 rounded-full bg-warning" />
                <p className="text-h5 text-black40">Danger Area</p>
            </div>
            <div className="flex w-full  items-center justify-start space-x-3">
                <div className="h-3 w-3 rounded-full bg-sky-600" />
                <p className="text-h5 text-black40">Tag Area</p>
            </div>
        </div>
    );
};

export default MapIndicator;
